class TagPriceSlider extends HTMLElement {
  connectedCallback() {
    this.minimum = Number(this.dataset.min) || 1;
    this.maximum = Number(this.dataset.max) || 500;
    this.minInput = this.querySelector('[data-price-min]');
    this.maxInput = this.querySelector('[data-price-max]');
    this.minOutput = this.querySelector('[data-price-min-output]');
    this.maxOutput = this.querySelector('[data-price-max-output]');

    if (!this.minInput || !this.maxInput) return;

    const params = new URLSearchParams(window.location.search);
    this.minInput.value = this.clamp(params.get('filter.v.price.gte'), this.minimum);
    this.maxInput.value = this.clamp(params.get('filter.v.price.lte'), this.maximum);

    if (Number(this.minInput.value) > Number(this.maxInput.value)) {
      this.minInput.value = this.maxInput.value;
    }

    this.addEventListener('input', this.onInput.bind(this));
    this.addEventListener('change', this.onChange.bind(this));
    this.updateDisplay();
    this.syncSortForm(params);

    if (params.has('filter.v.price.gte') || params.has('filter.v.price.lte')) {
      document.querySelectorAll('.tag-facets__active').forEach((element) => element.classList.remove('hidden'));
    }
  }

  clamp(value, fallback) {
    if (value === null || value === '') return fallback;

    const number = Number(value);
    if (!Number.isFinite(number)) return fallback;
    return Math.min(this.maximum, Math.max(this.minimum, Math.round(number)));
  }

  onInput(event) {
    if (event.target === this.minInput && Number(this.minInput.value) > Number(this.maxInput.value)) {
      this.minInput.value = this.maxInput.value;
    }
    if (event.target === this.maxInput && Number(this.maxInput.value) < Number(this.minInput.value)) {
      this.maxInput.value = this.minInput.value;
    }
    this.updateDisplay();
  }

  onChange(event) {
    if (event.target !== this.minInput && event.target !== this.maxInput) return;

    const url = new URL(window.location.href);
    url.searchParams.set('filter.v.price.gte', this.minInput.value);
    url.searchParams.set('filter.v.price.lte', this.maxInput.value);
    window.location.assign(url.toString());
  }

  updateDisplay() {
    const min = Number(this.minInput.value);
    const max = Number(this.maxInput.value);
    const span = this.maximum - this.minimum;
    const minPercent = span ? ((min - this.minimum) / span) * 100 : 0;
    const maxPercent = span ? ((max - this.minimum) / span) * 100 : 100;

    this.style.setProperty('--price-min-percent', `${minPercent}%`);
    this.style.setProperty('--price-max-percent', `${maxPercent}%`);
    this.minOutput.textContent = `$${min}`;
    this.maxOutput.textContent = `$${max}`;
  }

  syncSortForm(params) {
    const form = document.getElementById('FacetSortForm');
    if (!form) return;

    ['filter.v.price.gte', 'filter.v.price.lte'].forEach((name) => {
      const value = params.get(name);
      if (value === null || form.querySelector(`input[name="${name}"]`)) return;

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });
  }
}

if (!customElements.get('tag-price-slider')) {
  customElements.define('tag-price-slider', TagPriceSlider);
}
